import { InputLabel, MenuItem, Select } from '@mui/material'
import React, { useMemo } from 'react'
import { useLegDistrictsLuts, type UsFilters } from 'components'
import { type Role, type LegDistrict } from 'services'

export interface DistrictFiltersProps {
  filters: UsFilters
  value: Role
  updateDistrict: (type: LegDistrict | null) => void
  disabled: boolean
}

export const UsDistrictSelect: React.FC<DistrictFiltersProps> = ({ value, updateDistrict, disabled, filters }) => {
  const { lutValues: legDistrictValues } = useLegDistrictsLuts()
  const districtsToShow = useMemo<LegDistrict[]>(() => {
    let filtered = Array.from(legDistrictValues.districts.values())
    if (filters.chamber != null) {
      filtered = Array.from(filtered).filter((district: LegDistrict) => district.legchamber.id === filters.chamber?.id)
    }
    if (filters.state != null) {
      filtered = Array.from(filtered).filter((district: LegDistrict) => district.state.id === filters.state?.id)
    }
    return filtered
  }, [legDistrictValues.districts, filters])

  const handleChange = (value: string | number): void => {
    if (value !== '') {
      const mapResult = legDistrictValues.districts.get(Number(value)) ?? null
      updateDistrict(mapResult)
    } else {
      updateDistrict(null)
    }
  }

  return (
    <React.Fragment>
      <InputLabel>District</InputLabel>
      <Select
            label={'District'}
            id='district-select'
            value={value?.id ?? ''}
            disabled={disabled || (filters.chamber == null && filters.state == null)}
            onChange={(event) => { handleChange(event.target.value) }}>
            <MenuItem value=''>
              None
            </MenuItem>
            {districtsToShow.map(value => (<MenuItem key={value.id} value={value.id}>{value.desc} ({value.code})</MenuItem>))}
        </Select>
    </React.Fragment>
  )
}
